import '../styles/style.css'
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { authActions, getAuth } from '../../core/auth';
import { getNotification, notificationActions} from '../../core/notification'
import { paths } from '../routes';
import Header from '../components/header';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Notification from '../components/notification';

const muiTheme = getMuiTheme({
    palette: {
        primary1Color: '#4B8CC2',
        primary2Color: '#4B8CC2',
        accent1Color: '#00e676'
    }
});

export class App extends Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };

  static propTypes = {
    auth: PropTypes.object.isRequired,
    children: PropTypes.object.isRequired,
    signOut: PropTypes.func.isRequired
  };

  componentWillReceiveProps(nextProps) {
    const { router } = this.context;
    const { auth } = this.props;

    if (auth.authenticated && !nextProps.auth.authenticated) {
      router.replace(paths.SIGN_IN);
    }
    else if (!auth.authenticated && nextProps.auth.authenticated) {
      router.replace(paths.ON_OFF_CAMPUS);
    }
  }

  renderNotification() {
    const { notification } = this.props;
    return (
      <Notification
        actionLabel={notification.actionLabel}
        dismiss={this.props.dismissNotification}
        display={notification.display}
        message={notification.message}
      />
    );
  }

  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div>
          <Header
            authenticated={this.props.auth.authenticated}
            signOut={this.props.signOut}
          >

          <div className="main-content">{this.props.children}</div>
          {this.props.notification.display ? this.renderNotification() : null}
        </Header>
        </div>
      </MuiThemeProvider>
    );
  }
}


//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = createSelector(
  getAuth,
  getNotification,
  (auth, notification)  => ({auth, notification})
);

const mapDispatchToProps = Object.assign(
  {},
  authActions,
  notificationActions
)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/views/app/index.js